import React, { Component, Fragment } from "react";
import firebase from "../Firebase";
import { ReactComponent as Thermometer } from '../img/weatherIcons/wi-thermometer.svg'
import GoogleMapReact from 'google-map-react';
import Modal from '../components/Modal'
class Detail extends Component {
constructor(props) {
super(props);
this.ref = firebase.firestore().collection("test").orderBy("startDate", "desc");
this.unsubscribe = null;
this.state = {
boards: [],
};

}
onCollectionUpdate = (querySnapshot) => {
const boards = [];
querySnapshot.forEach((doc) => {
const {
    activity,
    algae,
    dead,
    date,
    habitat,
    observation,
    river,
    section,
    startDate,
    temperature,
    waterTemperature,
    weather,
    fieldNotes,
    lat,
    lon,
    

} = doc.data();
boards.push({
key: doc.id,
doc, // DocumentSnapshot
activity,
algae,
dead,
date,
habitat,
observation,
river,
section,
startDate,
temperature,
waterTemperature,
weather,
fieldNotes,
lat,
lon,

});

});
this.setState({
boards,
});
};
static defaultProps = {
  center: {
    lat: 39.3,
    lng: -107.1
  },
  zoom: 10
};

componentDidMount() {
this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
}

render() {

  const ThermalMarker = ({ water, lat, lng, date }) => <div className="map-col-2">
  <div className="center"> <Thermometer className="alert-icon-blk"/></div>
{/* <div className=""> {date} {lat} : {lng}</div> */}

<br/>

<div className="">
  <h3
style={{
marginLeft:"9px",
margin:"auto",
width:"35px",
height:"35px",
backgroundColor:"white",
borderRadius:"50%",
textAlign:"center",
paddingTop:"10px",
paddingBottom:"10px",

}}
>{water}º
</h3></div>
  </div>;
return (
<div className="body">

  <div className="canter">
  <h1>August 2020 Geo-tagged Hot Spots</h1>
  </div>

<div style={{ height: '70vh', width: '96%' }} className="card center">
<GoogleMapReact
  bootstrapURLKeys={{ key:'AIzaSyDP_7k3QlxgVxo-c8hM4g14lDJlrv59oXQ'}}
  defaultCenter={this.props.center}
  defaultZoom={this.props.zoom} >
    <ThermalMarker
         lat={39.399760}
         lng={-107.153816} 
         water={61}
         date='8/17/2020, 11:31:56 AM'
       />
    <ThermalMarker
         lat={39.480232 }
         lng={-107.287150} 
         water={60}
         date="8/15/2020, 1:25:13 PM"
       />
    <ThermalMarker
         lat={39.480}
         lng={ -107.287} 
         water={65}
         date="8/15/2020, 1:22:31 PM"
       />
    <ThermalMarker
         lat={39.521626}
         lng={-107.325228} 
         water={64}
         date="8/15/2020, 1:19:42 PM"
       />
    <ThermalMarker
         lat={39.480280}
         lng={-107.287152} 
         water={64}
         date="8/12/2020, 10:07:37 PM"
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={64}
         date="8/11/2020, 11:08:54 PM"
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={66}
         date="8/9/2020, 3:51:04 PM"
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={64}
         date="8/9/2020, 3:51:04 PM"
       />
    <ThermalMarker
         lat={39.332015}
         lng={-106.985789} 
         water={62}
         date="8/9/2020, 4:47:37 PM"
       />
    <ThermalMarker
         lat={39.2561}
         lng={-107.0533} 
         water={49}
         date="8/11/2020, 9:08:01 PM"
       />
    <ThermalMarker
         lat={39.2483141}
         lng={-107.2274389} 
         water={55}
         date="8/12/2020, 9:04:48 AM"
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={67}
         date="8/7/2020, 1:05:21 PM"
       />
    <ThermalMarker
         lat={39.5486402 }
         lng={-107.3226027} 
         water={67}
         date=""
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={68}
         date="8/7/2020, 7:56:56 AM"
       />
    <ThermalMarker
         lat={39.549573}
         lng={-107.329704} 
         water={66}
         date="8/7/2020, 1:03:01 PM"
       />
    <ThermalMarker
         date="8/9/2020, 3:51:04 PM"
         lat={39.549573}
         lng={-107.329704} 
         water={66}
       />
    <ThermalMarker
         date="8/9/2020, 3:51:04 PM"
         lat={39.343781}
         lng={-107.005057} 
         water={63}
       />
    <ThermalMarker
         date="8/9/2020, 3:51:04 PM"
         lat={39.343781}
         lng={-107.329704} 
         water={66}
       />
    <ThermalMarker
         date="8/4/2020, 7:03:26 AM"
         lat={39.461055}
         lng={-107.140913} 
         water={68}
       />
    <ThermalMarker
         date="8/4/2020, 7:08:13 AM"
         lat={39.464867}
         lng={-107.140774} 
         water={69}
       />
    <ThermalMarker
         date="8/3/2020, 4:59:15 PM"
         lat={39.26464}
         lng={-107.140774} 
         water={69}
       />
    <ThermalMarker
         date="8/1/2020, 4:32:20 PM"
         lat={39.343781}
         lng={-107.004892} 
         water={69}
       />
    <ThermalMarker
         date="8/1/2020, 2:36:31 PM"
         lat={39.480296}
         lng={-107.287205} 
         water={64}
       />


</GoogleMapReact>
</div>
</div>


);
}
}

export default Detail;